module.exports = __webpack_public_path__ + "img/btn_lung_off.c84b7128.svg";